import { GridPostList, Loader } from "@/components/shared";
import { useGetCurrentUser } from "@/lib/react-query/queries";
import { databases, appwriteConfig } from "@/lib/appwrite/config";
import { Query } from "appwrite";
import { useQuery } from "@tanstack/react-query";

const LikedPosts = () => {
  const { data: currentUser } = useGetCurrentUser();

  // ✅ NEW: Query posts liked by current user
  const { data: likedPosts, isLoading } = useQuery({
    queryKey: ["likedPosts", currentUser?.$id],
    queryFn: async () => {
      if (!currentUser) return [];
      
      const posts = await databases.listDocuments(
        appwriteConfig.databaseId,
        appwriteConfig.postCollectionId,
        [
          Query.contains("likedBy", currentUser.$id),
          Query.orderDesc("$createdAt"),
          Query.limit(50)
        ]
      );
      
      return posts.documents;
    },
    enabled: !!currentUser,
  });

  return (
    <>
      {!currentUser || isLoading ? (
        <div className="flex-center w-full h-full">
          <Loader />
        </div>
      ) : (
        <>
          {!likedPosts || likedPosts.length === 0 ? (
            <p className="text-light-4">No liked posts</p>
          ) : (
            <GridPostList posts={likedPosts} showStats={false} />
          )}
        </>
      )}
    </>
  );
};

export default LikedPosts;
